/** Normalise money from API/JSON to 2 dp (avoids float noise like 4999.999999). */
export function roundMoney2(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}
